import { withStyles } from '@material-ui/styles';
import { useEffect, useState } from 'react';
import { axiosInstance } from '../../utils/axiosInstance';
import { endpoint, localStorageKey } from '../../utils/constants';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import TableSerialNumbers from './TableSerialNumbers';

const styles = {
    root: {
        marginTop: '2rem',
        marginBottom: '2rem',
        height: 'calc(100vh - 6rem)',
    },
    loadingWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
    },
};

const SerialNumbers = ({ classes: { root, loadingWrapper } }) => {
    const [data, setData] = useState([]);
    const [isFetching, setIsFetching] = useState(true);
    const [isErrorLoadingData, setIsErrorLoadingData] = useState(false);
    const [waterpipesList, setWaterpipesList] = useState([]);
    const [isFetchingWaterpipes, setIsFetchingWaterpipes] = useState(true);

    useEffect(() => {
        fetchWaterpipes();
    }, []);

    useEffect(() => {
        if (!isFetchingWaterpipes) {
            fetchSerialNumbers();
        }
    }, [isFetchingWaterpipes]);

    const fetchWaterpipes = () => {
        axiosInstance
            .get(endpoint.PACKAGES, {
                params: {
                    chunk: 1,
                    page: 1,
                },
            })
            .then(content => {
                const { data: waterpipesData } = content.data.filters.waterpipes;
                localStorage.setItem(localStorageKey.WATERPIPES_LIST, JSON.stringify(waterpipesData));
                setWaterpipesList(waterpipesData);
            })
            .catch(err => {
                console.error('Error while fetching waterpipes', err);
            })
            .finally(() => {
                setIsFetchingWaterpipes(false);
            });
    };

    const fetchSerialNumbers = () => {
        setIsFetching(true);
        setIsErrorLoadingData(false);

        axiosInstance
            .get(endpoint.SERIAL_NUMBERS_SHOW)
            .then(res => {
                setData(res?.data?.data ?? []);
            })
            .catch(err => {
                console.error('Error while fetching serial numbers', err);
                setIsErrorLoadingData(true);
            })
            .finally(() => {
                setIsFetching(false);
            });
    };

    return (
        <div className={root}>
            {isFetchingWaterpipes || (isFetching && !data.length) ? (
                <div className={loadingWrapper}>
                    <LoadingSpinner />
                </div>
            ) : (
                <TableSerialNumbers
                    data={data}
                    isFetching={isFetching}
                    isErrorLoadingData={isErrorLoadingData}
                    waterpipesList={waterpipesList}
                />
            )}
        </div>
    );
};

export default withStyles(styles)(SerialNumbers);
